let revealObserver = null;

const REVEAL_SELECTORS = [
  ".hero",
  ".section",
  "section.hero",
  "section.section",
  "section.background-section",
  "section.showcase-section",
  "section.features-section",
  "section.specs-section",
  "section.reviews-section",
  "section.overview",
  "section.features",
  "section.ui-showcase",
  "section.tech-specs",
  "section.user-value",
  "section.project-intro",
  "section.poster-banner",
  "section.page-summary",
  "section.related-cases",
  "section.showcase",
  "section.screens-section",
].join(", ");

export function destroyRichHtmlReveal() {
  if (revealObserver) {
    revealObserver.disconnect();
    revealObserver = null;
  }
}

export function initRichHtmlReveal(rootEl) {
  destroyRichHtmlReveal();

  if (!rootEl || typeof IntersectionObserver === "undefined") {
    return;
  }

  const nodes = rootEl.querySelectorAll(REVEAL_SELECTORS);
  if (!nodes.length) {
    return;
  }

  nodes.forEach((el) => {
    el.classList.remove("revealed");
  });

  revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
  );

  nodes.forEach((el) => {
    if (el.classList.contains("hero")) {
      el.classList.add("revealed");
    }
    revealObserver.observe(el);
  });

  requestAnimationFrame(() => {
    const hero = rootEl.querySelector(".hero");
    if (hero) {
      hero.classList.add("revealed");
    }
  });
}
